export default __webpack_public_path__ + "static/media/user_avatar.520b6ae6.svg";